// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shuppet: PokeData = {
  "id": 353,
  "name": "shuppet",
  "height": 6,
  "weight": 23,
  "base_experience": 59,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "night-shade",
    "screech",
    "curse",
    "spite",
    "feint-attack",
    "pain-split",
    "shadow-ball",
    "will-o-wisp",
    "trick",
    "role-play",
    "knock-off",
    "grudge",
    "snatch",
    "astonish",
    "embargo",
    "sucker-punch",
    "shadow-sneak",
    "hex",
    "phantom-force"
  ],
  "moves": [
    "night-shade",
    "curse",
    "shadow-ball",
    "snatch",
    "shadow-sneak",
    "phantom-force",
    "poltergeist",
    "confuse-ray",
    "shadow-dagger",
    "shadow-claws",
    "soul-sacrifice",
    "spectral-snatch",
    "lick"
  ],
  "evolution_chain": {
    "id": 181,
    "item": null,
    "species": [
      {
        "name": "shuppet",
        "order": 381,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "banette",
        "order": 382,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 353,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 39,
    "speed": 45,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
